import React, {useCallback ,useState} from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import {useHistory} from "react-router-dom";
import {primaryColor} from "../../style.scss";
import {connect} from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import {makeStyles, withStyles} from "@material-ui/core/styles";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import QrReader from 'react-qr-reader'
import {SpinnerComponent} from "react-element-spinner";
import {JWalletQRCodesApi} from "eclipse-react-sdk/services";
import qr_example from "../../assets/img/qr_example.svg"
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import {useLocation} from "react-router-dom";
import Button from "../../components/CustomButtons/Button";
import Danger from "../../components/Typography/Danger";
import formStyle from "../../assets/jss/eclipse/components/formStyle";
import {TextField} from "@material-ui/core";
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog.js';


const useStyles = makeStyles(themeStyle);
const ValidationTextField = withStyles(formStyle)(TextField);

export function ScanPayShapQR(props) {
  const history = useHistory();
  const classes = useStyles();
  const fromScreen = useLocation()?.state?.fromScreen;
  const [isLoading, setLoading] = useState(false);
  const [qrCodeData, setQrCodeData] = useState("");
  const [errors, setErrors] = useState({});
  const [alertData, setAlert] = useState(null);
  const [openConfirmDialog, setOpen] = useState(false);

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message})
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const validateQRCode = (qrCode) => {
    return qrCode && qrCode.length > 0;
  }

  const redirectToErrorScreen = (fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: {fromScreen: fromScreen}
    });
  }

  const backToTransact = () => {
    history.push(`/pages/transact`);
  }

  const goToPayAmount = (scannedQRData,shapID) => {
    if(shapID){
    history.push({
      pathname: '/pages/pay-payshap-amount',
      state: {scannedQRData: scannedQRData, fromScreen: fromScreen, shapID: shapID }
    });
  }
  else{
    opendialog()
  }
  }

  const handleScan = (qrCodeData) => {
    if (validateQRCode(qrCodeData)) {
      doValidateQR(qrCodeData);
   }
  }
  const opendialog = ()=> {
    setOpen(true);
  }

  const closeDialog = () => {
    window.location.reload()
    setOpen(false)
  };
  const backToDashboard = useCallback(() => {
    history.push({
      pathname: '/pages/dashboard',
    });
  }, [history])

  const handleSubmit = (event) => {
    event.preventDefault();
    if(qrCodeData?.trim().length===0){
      setErrors({ qrcode: "The ShapID is required" });
    }
     else if (validateQRCode(qrCodeData)) {
      doValidateQR(qrCodeData);
    }
    else{
      doValidateQR(qrCodeData);
    }
  }
  const parseShapID =(qrCodeData) => {
  const pattern = /\.payshap(\d{4})(\d+?)@([a-zA-Z]+)/;
  const match = qrCodeData.match(pattern);

  if (match) {
    const fullparseData = match[0];
    const afterPayShap = fullparseData.split("payshap")    
    const lengthOfShapID =  Number(afterPayShap[1].substring(2,4))
    const shapID = afterPayShap[1].substring(4,lengthOfShapID+4)
    return shapID
  }
    else
    return null;
  }
  
  const handleInputChange = (event) => {
    const { value } = event?.target;
    event.persist()
    setQrCodeData(value);
    if (value.length === 0) {
      setErrors({ qrcode: "The ShapID is required" });
    } else {
      setErrors({});
    }
  }
  const doValidateQR = (qrCodeData) => {
    const shapID = parseShapID(qrCodeData);
    setLoading(true);
    const qrCodesApi = new JWalletQRCodesApi();
    qrCodesApi.tenantsTenantIdWalletsQrCodesCodeGet(props?.appData?.auth?.tenantId, qrCodeData).then((qrAPIResponse) => {
      setLoading(false);
      goToPayAmount(qrAPIResponse.data,shapID);
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error?.response && error?.response?.data && error?.response?.data?.length > 0 && error?.response?.data[0]?.description) {
        opendialog()
      } else {
        redirectToErrorScreen('/pages/payshap-qr', '/pages/error');
      }
    });
  }

  const handleError =()=> {
    showAlert(true, 'ERROR', `QR Code is invalid or not found. Please try again!`);
  }

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor}/>
      <ConfirmationDialog open={openConfirmDialog}
        title="Invalid QR code"
        message="The QR code is not a valid PayShap QR code. Please try again or scan another PayShap QR code."
        onCancel={backToDashboard}
        onConfirm={closeDialog}
        cancelText="Cancel"
        confirmText="Try Again">
      </ConfirmationDialog>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{display: 'flex'}}>
              <ArrowBackIosIcon className={classes?.linkColor} onClick={backToTransact}/>
              <span className={classes?.title}>Pay a PayShap QR code</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{}} className={classes.textCenter}>
              <p className={classes?.regularFontSize + ' ' + classes?.textCenter + ' m-t-0 m-b-0'} style={{
                width: '100%',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}><img src={qr_example} alt=''/><b style={{verticalAlign: 'middle'}}>Scan the PayShap QR code</b>
              </p>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div className="qr-scan-area">
                <QrReader
                  delay={600}
                  onError={handleError}
                  onScan={handleScan}
                  style={{width: '100%'}}
                />
              </div>
            </GridItem>
            <GridItem>
              <form onSubmit={handleSubmit}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <p style={{textAlign: 'center'}}><b>OR</b></p>
                  </GridItem>
                  <GridItem  xs={12} sm={12} md={12} style={{display:"flex",alignItems:'center',justifyContent:'center',gap:10}} >
                    <ValidationTextField
                      fullWidth
                      label="Enter the PayShap QR code number"
                      variant="filled"
                      id="qrcode"
                      type="text"
                      error={!!(errors?.qrcode)}
                      name="card"
                      value={qrCodeData}
                      onChange={handleInputChange}/>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} style={{paddingTop: '0px'}}>
                    {errors?.qrcode && <Danger><small>{errors?.qrcode}</small></Danger>}
                  </GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <Button onClick={backToTransact}
                            className={classes?.buttonRadius} size="lg" block
                            color="transparent">Back</Button>
                  </GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <Button className={classes?.buttonRadius} size="lg" block color="primary"
                            type="submit"
                            disabled={!!errors?.qrcode}>Next</Button>
                  </GridItem>
                </GridContainer>
              </form>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData}/> : null}
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state?.applicationData?.appData
})

const mapDispatchToProps = dispatch => ({})
export default connect(mapStateToProps, mapDispatchToProps)(ScanPayShapQR)
